/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandableItemCheck } from "./d-theme-white-menu-item-expandable-item-check";

export class DThemeWhiteMenuSidedItemExpandableItemCheck extends DThemeWhiteMenuItemExpandableItemCheck {}
